import React, { useState, useEffect } from 'react';
import './Archive.css';

const Archive = () => {
  const [artworks, setArtworks] = useState([]);
  const [selectedArtwork, setSelectedArtwork] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArtworks();
  }, []);

  const fetchArtworks = async () => {
    try {
      const response = await fetch('/api/artworks');
      const data = await response.json();
      if (Array.isArray(data)) {
        setArtworks(data);
      } else {
        throw new Error('Invalid data');
      }
    } catch (error) {
      console.error('Eserler yüklenirken hata:', error);
      // Fallback data if backend is not running
      setArtworks([
        {
          _id: '1',
          title: 'Karlı Köy Sokağı',
          description: 'Anadolu köyünde kış manzarası',
          imageUrl: '/images/artwork1.jpg',
          year: 2024,
          technique: 'Yağlı Boya',
          dimensions: '50x70 cm',
          category: 'Manzara'
        },
        {
          _id: '2',
          title: 'İstanbul Silueti',
          description: 'Denizden İstanbul manzarası, tarihi yarımada',
          imageUrl: '/images/artwork2.jpg',
          year: 2024,
          technique: 'Yağlı Boya',
          dimensions: '60x80 cm',
          category: 'Manzara'
        },
        {
          _id: '3',
          title: 'Kış Günü',
          description: 'Kar altında köy evleri',
          imageUrl: '/images/artwork3.jpg',
          year: 2023,
          technique: 'Yağlı Boya',
          dimensions: '40x50 cm',
          category: 'Manzara'
        },
        {
          _id: '4',
          title: 'Boğaz Manzarası',
          description: 'İstanbul Boğazı ve camiler',
          imageUrl: '/images/artwork4.jpg',
          year: 2023,
          technique: 'Yağlı Boya',
          dimensions: '50x60 cm',
          category: 'Manzara'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (artwork) => {
    setSelectedArtwork(artwork);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedArtwork(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="archive">
      <div className="archive-header">
        <span className="section-label">Koleksiyon</span>
        <h1>Eser Arşivi</h1>
        <p>Yağlı boya tekniğiyle hayat bulan tüm eserler</p>
      </div>

      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Eserler yükleniyor...</p>
        </div>
      ) : (
        <div className="archive-grid">
          {artworks.map((artwork, index) => (
            <div 
              key={artwork._id} 
              className="artwork-card"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => openModal(artwork)}
            >
              <div className="artwork-image">
                <img src={artwork.imageUrl} alt={artwork.title} />
                <div className="artwork-overlay">
                  <span className="view-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="11" cy="11" r="8"/>
                      <path d="M21 21l-4.35-4.35"/>
                      <path d="M11 8v6M8 11h6"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="artwork-info">
                <h3>{artwork.title}</h3>
                <p>{artwork.technique}, {artwork.year}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedArtwork && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div className="modal-image">
              <img src={selectedArtwork.imageUrl} alt={selectedArtwork.title} />
            </div>
            <div className="modal-info">
              <h2>{selectedArtwork.title}</h2>
              <p className="modal-description">{selectedArtwork.description}</p>
              <div className="modal-details">
                <div className="detail">
                  <span className="detail-label">Teknik</span>
                  <span className="detail-value">{selectedArtwork.technique}</span>
                </div>
                {selectedArtwork.dikey && selectedArtwork.yatay && (
                  <div className="dimension-box">
                    <div className="dimension-visual">
                      <div className="dimension-label dikey">
                        <span>{selectedArtwork.dikey} cm</span>
                        <span className="dimension-name">Dikey</span>
                      </div>
                      <div className="dimension-canvas"></div>
                      <div className="dimension-label yatay">
                        <span>{selectedArtwork.yatay} cm</span>
                        <span className="dimension-name">Yatay</span>
                      </div>
                    </div>
                  </div>
                )}
                {selectedArtwork.dimensions && (
                  <div className="detail">
                    <span className="detail-label">Boyut</span>
                    <span className="detail-value">{selectedArtwork.dimensions}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Archive;
